export const priceToFixed = price => price && price.toFixed(2);
